import { render } from "./ResetUsername.vue?vue&type=template&id=c1e64f4e&scoped=true"
import script from "./ResetUsername.vue?vue&type=script&lang=js"
export * from "./ResetUsername.vue?vue&type=script&lang=js"

import "./ResetUsername.vue?vue&type=style&index=0&id=c1e64f4e&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e64f4e"]])

export default __exports__